import React from 'react';
import { Project } from '../utils/mockData';
interface ProjectsTooltipProps {
  projects: Project[];
  position: {
    x: number;
    y: number;
  };
}
export const ProjectsTooltip: React.FC<ProjectsTooltipProps> = ({
  projects,
  position
}) => {
  if (projects.length === 0) {
    return null;
  }
  return <div className="absolute z-50 w-80 p-4 rounded-md shadow-lg bg-popover border text-popover-foreground" style={{
    left: `${position.x}px`,
    top: `${position.y + 10}px`
  }} onClick={e => e.stopPropagation()} data-id="element-37">
      <h3 className="font-medium mb-2" data-id="element-38">Projects ({projects.length})</h3>
      <div className="space-y-3 max-h-80 overflow-y-auto" data-id="element-39">
        {projects.map(project => <div key={project.id} className="p-3 rounded-md bg-muted/50 border text-sm" data-id="element-40">
            <div className="font-medium mb-1" data-id="element-41">{project.address}</div>
            <div className="grid grid-cols-2 gap-x-2 gap-y-1 text-xs" data-id="element-42">
              <div className="text-muted-foreground" data-id="element-43">Finance:</div>
              <div className="capitalize" data-id="element-44">{project.financeOption}</div>
              <div className="text-muted-foreground" data-id="element-45">Finance Status:</div>
              <div className="capitalize" data-id="element-46">
                <span className={getFinanceStatusColor(project.financeStatus)} data-id="element-47">
                  {project.financeStatus}
                </span>
              </div>
              <div className="text-muted-foreground" data-id="element-48">Project Status:</div>
              <div className="capitalize" data-id="element-49">
                <span className={getProjectStatusColor(project.projectStatus)} data-id="element-50">
                  {project.projectStatus}
                </span>
              </div>
            </div>
          </div>)}
      </div>
    </div>;
};
function getFinanceStatusColor(status: string): string {
  switch (status) {
    case 'pre-approved':
      return 'text-amber-600';
    case 'declined':
      return 'text-red-600';
    case 'finance accepted':
      return 'text-green-600';
    default:
      return '';
  }
}
function getProjectStatusColor(status: string): string {
  switch (status) {
    case 'pending':
      return 'text-amber-600';
    case 'accepted':
      return 'text-blue-600';
    case 'scheduled':
      return 'text-purple-600';
    case 'commissioned':
      return 'text-green-600';
    default:
      return '';
  }
}